import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
import { GameState, GameStatus, CORE_RADIUS, ORBIT_RADIUS, BALL_RADIUS, BALLS_TO_SHOOT, ADV_ROUND } from '@utils/game/aaGame/constants.js';
import { aesEncrypt, getRandomElement, isOpenMobile } from '@utils/index.js';
import { gameAdv } from "@utils/gameAdv.js";
import vailcode from "@utils/errcode";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "aaGamePage",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    nextBtnText() {
      return (this.gameState.level + 1) % ADV_ROUND === 0 ? this.$lang('Continue (Ad)') : this.$lang('Next Level');
    }
  },
  data() {
    return {
      gameState: {
        ...GameState
      },
      GameStatus,
      revives: 10,
      maxRevives: 10,
      CANVAS_WIDTH: 0,
      CANVAS_HEIGHT: 0,
      lastScore: 0,
      timeVal: null,
      stimeVal: null,
      leftTime: 0,
      prizePool: 0,
      timePeriod: "",
      userReward: null,
      popUserRewardShow: false,
      popGameRankShow: false,
      popStartShow: false,
      popLostShow: false,
      popWinShow: false,
      popOpenMobileShow: false,
      engine: {
        currentRotation: 0,
        ballsOnCore: [],
        shootingBall: null,
        shakeIntensity: 0,
        lastFrameTime: performance.now()
      },
      requestId: null,
      animationId: null
    };
  },
  watch: {
    'gameState.status'(newStatus, oldStatus) {
      if (newStatus === this.GameStatus.GAMEOVER) {
        this.popLostShow = true;
      }
      if (newStatus === this.GameStatus.LEVEL_WIN) {
        this.popWinShow = true;
      }
    },
    'gameState.score': {
      handler() {
        clearTimeout(this.timeVal);
        this.timeVal = setTimeout(() => {
          this.end();
        }, 200);
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    try {
      clearTimeout(this.stimeVal);
      this.end();
    } catch (error) {}
    this.$nextTick(() => {
      next();
    });
    cancelAnimationFrame(this.requestid);
    cancelAnimationFrame(this.animationId);
  },
  methods: {
    initLevel(levelNum = 1) {
      const callback = res => {
        this.popStartShow = false;
        this.popLostShow = false;
        this.popWinShow = false;
        this.gameState.initialBalls = 2 + Math.floor(levelNum / 4);
        this.gameState.remainingBalls = BALLS_TO_SHOOT + Math.floor(levelNum * 1.5);
        const initialBalls = [];
        for (let i = 0; i < this.gameState.initialBalls; i++) {
          initialBalls.push({
            id: -1 - i,
            angle: Math.PI * 2 / this.gameState.initialBalls * i
          });
        }

        // 重置物理引擎数据
        this.engine = {
          currentRotation: 0,
          ballsOnCore: initialBalls,
          shootingBall: null,
          shakeIntensity: 0,
          lastFrameTime: performance.now()
        };
        this.gameState.status = this.GameStatus.PLAYING;
        this.gameState.level = levelNum;
        if (levelNum === 1) {
          this.gameState.score = 0;
          this.revives = this.maxRevives;
        }
      };
      try {
        // 广告轮次判断
        if (levelNum % ADV_ROUND === 0) {
          let advData = getRandomElement(this.advList);
          if (advData) {
            gameAdv.show(advData, this.timePeriod, res => {
              callback(res);
            }, this);
          } else {
            callback(null);
          }
        } else {
          callback(null);
        }
      } catch (e) {
        callback(null);
      }
    },
    /** 点击发射 */
    handleShoot() {
      if (this.gameState.status !== this.GameStatus.PLAYING || this.gameState.remainingBalls <= 0 || this.engine.shootingBall) return;
      this.engine.shootingBall = {
        y: window.innerHeight * 0.85,
        id: Date.now()
      };
      this.gameState.remainingBalls = this.gameState.remainingBalls - 1;
    },
    /** 复活逻辑 */
    handleRevive() {
      if (this.revives <= 0) return;
      const callback = res => {
        this.popLostShow = false;
        this.revives = this.revives - 1 >= 0 ? this.revives - 1 : 0;
        this.engine.shootingBall = null;
        this.engine.shakeIntensity = 30;
        this.gameState.status = this.GameStatus.PLAYING;
        this.gameState.remainingBalls = this.gameState.remainingBalls + 1;
        this.gameState.revivalsUsed = this.gameState.revivalsUsed + 1;
      };
      try {
        let advData = getRandomElement(this.advList);
        if (advData) {
          gameAdv.show(advData, this.timePeriod, res => {
            callback(res);
          }, this);
        } else {
          callback(null);
        }
      } catch (e) {
        callback(null);
      }
    },
    /** 
     * 物理更新循环
     */
    updatePhysics(time) {
      const deltaTime = (time - this.engine.lastFrameTime) / 1000;
      this.engine.lastFrameTime = time;
      const engine = this.engine;

      // 震动衰减
      if (engine.shakeIntensity > 0) {
        engine.shakeIntensity = Math.max(0, engine.shakeIntensity - 60 * deltaTime);
      }
      if (this.gameState.status === this.GameStatus.PLAYING) {
        // 恒定旋转计算
        engine.currentRotation += this.gameState.rotationSpeed * deltaTime;

        // 小球飞行模拟
        if (engine.shootingBall) {
          const flySpeed = 1500;
          engine.shootingBall.y -= flySpeed * deltaTime;
          const targetY = this.CANVAS_HEIGHT * 0.4 + ORBIT_RADIUS;
          if (engine.shootingBall.y <= targetY) {
            const shootAngle = Math.PI / 2;
            const COLLISION_THRESHOLD = 0.08;
            const collision = engine.ballsOnCore.some(ball => {
              const absAngle = (engine.currentRotation + ball.angle) % (Math.PI * 2);
              let diff = Math.abs(absAngle - shootAngle);
              if (diff > Math.PI) diff = Math.PI * 2 - diff;
              console.log(diff);
              return diff < COLLISION_THRESHOLD;
            });
            if (collision) {
              engine.shakeIntensity = 25;
              this.gameState.status = this.GameStatus.GAMEOVER;
            } else {
              engine.ballsOnCore.push({
                id: engine.shootingBall.id,
                angle: shootAngle - engine.currentRotation
              });
              const nextScore = this.gameState.score + 10 * this.gameState.level;
              this.gameState.score = nextScore;
              this.gameState.status = this.gameState.remainingBalls === 0 ? this.GameStatus.LEVEL_WIN : this.GameStatus.PLAYING;
            }
            engine.shootingBall = null;
          }
        }
      }
      this.requestId = requestAnimationFrame(this.updatePhysics);
    },
    /** 主渲染循环 */
    renderLoop() {
      const engine = this.engine; // React.useRef.current → Vue props
      const ctx = this.ctx;
      const width = this.CANVAS_WIDTH;
      const height = this.CANVAS_HEIGHT;
      const shakeX = engine.shakeIntensity > 0 ? (Math.random() - 0.5) * engine.shakeIntensity : 0;
      const shakeY = engine.shakeIntensity > 0 ? (Math.random() - 0.5) * engine.shakeIntensity : 0;

      // 背景
      ctx.fillStyle = "#000";
      ctx.fillRect(0, 0, width, height);

      // 闪光
      if (engine.shakeIntensity > 15) {
        ctx.fillStyle = `rgba(255,255,255,${engine.shakeIntensity / 100})`;
        ctx.fillRect(0, 0, width, height);
      }
      const centerX = width / 2 + shakeX;
      const centerY = height * 0.4 + shakeY;
      const coreRadius = CORE_RADIUS;
      const orbitRadius = ORBIT_RADIUS;
      const ballRadius = BALL_RADIUS;
      const isGameOver = engine.shakeIntensity > 5 && this.gameState.status === this.GameStatus.GAMEOVER;

      /** ===== 核心圆 ===== */
      ctx.beginPath();
      ctx.arc(centerX, centerY, coreRadius, 0, Math.PI * 2);
      ctx.fillStyle = isGameOver ? "#ef4444" : "#ffffff";
      ctx.fill();

      /** 核心数字 */
      ctx.fillStyle = isGameOver ? "#ffffff" : "#000000";
      ctx.font = "900 28px Inter, sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(this.gameState.remainingBalls, centerX, centerY);

      /** ===== 核心上的球 ===== */
      engine.ballsOnCore.forEach(ball => {
        const angle = engine.currentRotation + ball.angle;
        const x = centerX + Math.cos(angle) * orbitRadius;
        const y = centerY + Math.sin(angle) * orbitRadius;
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.lineTo(x, y);
        ctx.strokeStyle = "rgba(255,255,255,0.2)";
        ctx.lineWidth = 1.5;
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x, y, ballRadius, 0, Math.PI * 2);
        ctx.fillStyle = "#ffffff";
        ctx.fill();
      });

      /** ===== 飞行中的球 ===== */
      if (engine.shootingBall) {
        ctx.beginPath();
        ctx.arc(centerX, engine.shootingBall.y, ballRadius, 0, Math.PI * 2);
        ctx.fillStyle = "#ffffff";
        ctx.fill();
      }

      /** ===== 待发射球 ===== */
      if (this.gameState.status === "PLAYING" && !engine.shootingBall) {
        ctx.beginPath();
        ctx.arc(centerX, height * 0.85, ballRadius, 0, Math.PI * 2);
        ctx.fillStyle = "#ffffff";
        ctx.fill();
      }

      // 下一帧
      this.animationId = requestAnimationFrame(this.renderLoop);
    },
    async start() {
      let rs = await this.$http.post("/game/start", {
        game_type: "aaGame"
      });
      vailcode(rs, () => {
        this.prizePool = rs.data.keys ?? 0;
        this.timePeriod = rs.data.time_period ?? "";
        this.leftTime = rs.data.left_time ?? 0;
        this.lastScore = rs.data.last_score ?? 0;
      });
    },
    async end() {
      if (this.lastScore >= this.gameState.score) return;
      this.lastScore = this.gameState.score;
      let gameData = aesEncrypt(JSON.stringify({
        game_type: "aaGame",
        level: this.gameState.level,
        score: this.gameState.score,
        time_period: this.timePeriod,
        time: new Date().getTime()
      }));
      let rs = await this.$http.post("/game/score", {
        gameData: gameData,
        '_n': 1
      });
      if (rs.code == 0) {
        // this.level = rs.data.level ?? 1;
        // this.score = rs.data.score ?? 0;
        this.prizePool = rs.data.keys ?? 0;
      }
    },
    async init() {
      let rs = await this.$http.post("/game/init", {
        game_type: "aaGame"
      });
      vailcode(rs, () => {
        this.leftTime = rs.data.left_time ?? 0;
        this.prizePool = rs.data.keys ?? 0;
        this.advList = rs.data.advList ?? [];
        this.timePeriod = rs.data.time_period ?? "";
        this.userReward = rs.data.userReward ?? null;
        if (this.userReward?.total_keys > 0 || this.userReward?.total_taps > 0) {
          setTimeout(() => {
            this.popUserRewardShow = true;
          }, 500);
        }
        this.countDown();
      });
    },
    countDown() {
      clearTimeout(this.stimeVal);
      this.leftTime = this.leftTime - 1;
      this.$nextTick(async () => {
        if (this.leftTime <= 0) {
          await this.init();
          this.gameState = this.GameState.MENU;
        } else {
          this.stimeVal = setTimeout(() => {
            this.countDown();
          }, 1000);
        }
      });
    },
    handleCancel() {
      this.popLostShow = false;
      this.gameState.status = this.GameStatus.IDLE;
      this.popStartShow = true;
    },
    handleConfirm() {
      this.revives > 0 ? this.handleRevive() : this.handleCancel();
    },
    async handleGetRewardConfirm() {
      let rs = await this.$http.post("/game/get/reward", {
        game_type: "aaGame"
      });
      vailcode(rs, () => {
        this.popUserRewardShow = false;
      });
    },
    viewRank() {
      this.$nextTick(() => {
        //  this.$router.push(`/game/rank`)
        //  console.log(this.$router)
        this.end();
        this.popGameRankShow = true;
      });
    }
  },
  async mounted() {
    if (!isOpenMobile()) {
      this.popOpenMobileShow = true;
      return;
    }
    await this.init();
    this.gameState.status = this.GameStatus.IDLE;
    const gameCenterBox = this.$refs.gameCenterBox;
    this.CANVAS_WIDTH = gameCenterBox.clientWidth;
    this.CANVAS_HEIGHT = Math.floor(gameCenterBox.clientWidth * 1.3);
    this.popStartShow = true;
    this.ctx = this.$refs.canvasRef.getContext("2d", {
      alpha: false
    });
    this.requestID = requestAnimationFrame(this.updatePhysics);
    this.animationId = requestAnimationFrame(this.renderLoop);
  }
};